import * as Types from '../../../../../__generated__/graphql/types';

import { gql } from '@apollo/client';
export type FeedbackButton_FeatureFlagsFragment = { __typename?: 'FeatureFlags', submitFeedback: boolean };

export const FeedbackButton_FeatureFlagsFragmentDoc = gql`
    fragment FeedbackButton_featureFlags on FeatureFlags {
  submitFeedback
}
    `;